import styled from 'styled-components';
import { BLACK, MOBILE_PADDING } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrap = styled.section`
  max-width: 1060px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 ${MOBILE_PADDING}px;
`;

export const Title = styled.h5`
  position: relative;
  margin: 0 0 60px;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }
`;

export const SubTitle = styled.h6`
  margin: 30px auto 20px;
  font-size: 14px;
`;
export const TimeText = styled.h6`
  margin: 30px auto;
  font-size: 12px;
`;
export const ListLabel = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  > span {
    font-size: 14px;
    text-align: left;
    &:nth-child(1) {
      width: 200px;
      ${media.tabletL`
        width: 250px;
      `};
    }
  }
`;
export const ListSection = styled.ul`
  max-width: 1060px;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  margin-bottom: 85px;
  > li {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 20px 20px 20px 0;
    color: #000;
    > dt {
      font-size: 12px;
      width: 200px;
      text-align: top;
      ${media.tabletL`
        width: 250px;
      `};
    }
    > dd {
      font-size: 14px;
      flex: 1;
      margin-bottom: 0;
      > p {
        margin-bottom: 0;
      }
    }
  }
  > li:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/ContactUs/ContactUs.style.js